// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-md-dialog-close] {
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px;
}

.headline {
    justify-content: center;
}

.modalContent {
    padding: 0.5em;
    padding-inline: 1em;
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/common-modal.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB","sourcesContent":["[data-md-dialog-close] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 5px;\n}\n\n.headline {\n    justify-content: center;\n}\n\n.modalContent {\n    padding: 0.5em;\n    padding-inline: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
